

export const log = {
    log() {
        var hideConsole = false
        if(!hideConsole){
            for (var i = 0; i < arguments.length; ++i)
                // eslint-disable-next-line prefer-rest-params
                console.log(arguments[i]);
        }
    }
}
